import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { LoginService } from '../../componentes/login/service/login.service';
import { CadastroService } from '../../componentes/cadastro/service/cadastro.service';
import { PessoaEditModel } from '../../models/pessoa-Edit.Model';
import { I18nService } from '../../service/i18n.service';
import { Language } from '../api/language';
import { LayoutService } from '../service/app.layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MenubarModule,
    AvatarModule,
    FormsModule,
    CommonModule,
    TieredMenuModule,
    TranslateModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  public layoutService = inject(LayoutService);
  public translate = inject(TranslateService);
  private i18nService = inject(I18nService);
  private loginService = inject(LoginService);
  private cadastroService = inject(CadastroService);
  private router = inject(Router);
  items: MenuItem[] | undefined;
  idioma!: Language;
  userAvatarUrl: string | undefined = undefined;

  ngOnInit() {
    this.iniciarOpcoesCabecalho();
    this.carregarDadosUsuario();
  }

  /**
   * Carrega dados do usuário incluindo foto de perfil
   */
  private carregarDadosUsuario(): void {
    this.cadastroService.buscarUsuario().then((usuario: PessoaEditModel) => {
      // Verifica se existe uma imagem associada ao usuário
      if (usuario.imagemPerfil) {
        // Cria a URL Base64 para exibição
        this.userAvatarUrl = `data:${usuario.typeImage || 'image/png'};base64,${usuario.imagemPerfil}`;
      }
    }).catch((error) => {
      console.error('Erro ao carregar dados do usuário:', error);
    });
  }

  iniciarOpcoesCabecalho() {
    this.items = [
      {
        label: 'CABECALHO.PERFIL',
        icon: 'pi pi-user',
      },
      {
        label: 'CABECALHO.IDIOMAS.TITULO',
        icon: 'pi pi-globe',
        items: [
          {
            label: 'CABECALHO.IDIOMAS.INGLES',
            command: () => {
              this.mudarIdioma('en');
            },
          },
          {
            label: 'CABECALHO.IDIOMAS.PORTUGUES_BRASIL',
            command: () => {
              this.mudarIdioma('pt');
            },
          },
        ],
      },
      {
        label: 'CABECALHO.SUPORTE',
        icon: 'pi pi-question',
      },
      { separator: true },
      {
        label: 'CABECALHO.SAIR',
        icon: 'pi pi-sign-out',
        command: () => {
          this.logout();
        },
      },
    ];
  }

  mudarIdioma(idioma: string) {
    this.translate.use(idioma.toLocaleLowerCase()!);
    this.i18nService.idioma.next({ code: idioma });
  }

  logout() {
    this.loginService.logout().subscribe(() => {
      this.router.navigate(['/']);
    });
  }

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }
}
